<template>
  <div class="card-container">
    <card class="card-login card-white">
      <Header pageTitle="Change Password"></Header>
      <div>
        <div v-if="!passwordChanged">
          <base-input
            v-validate="'required|min:15'"
            :error="getError('oldpassword')"
            v-model="oldPasswordInput"
            name="oldpassword"
            type="password"
            placeholder="Old password"
            addon-left-icon="tim-icons icon-lock-circle"
          >
          </base-input>

          <base-input
            v-validate="'required|min:15'"
            :error="getError('new password')"
            v-model="newPasswordInput"
            name="new password"
            type="password"
            placeholder="New password"
            addon-left-icon="tim-icons icon-lock-circle"
          >
          </base-input>

          <base-input
            v-validate="'required|min:15'"
            :error="getError('confirmpassword')"
            v-model="confirmPasswordInput"
            name="confirmpassword"
            type="password"
            placeholder="Confirm password"
            addon-left-icon="tim-icons icon-lock-circle"
          >
          </base-input>

          <div class="larger-font black" style="padding-bottom: 5px;">
            {{ passwordRulesInfo }}
          </div>

          <div class="reset_password_button_grid">
            <base-button
              @click="onResetPasswordClicked"
              :disabled="isDisabled"
              type="primary"
              style="grid-column: 2 / span 1; margin-bottom: 10px;"
            >
              Reset password
            </base-button>
          </div>
        </div>

        <p>
          {{ resetPasswordMessage }}
        </p>
      </div>

      <div slot="footer">
        <div v-if="!passwordChanged" class="reset_password_button_grid">
          <base-button
            @click="onReturnToLoginClicked"
            type="primary"
            style="grid-column: 2 / span 1; margin-bottom: 10px;"
          >
            Cancel
          </base-button>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import axios from "@/axios";
import Header from "@/components/App/Header";

export default {
  name: "ChangePassword",
  mixins: [Utility],
  components: {
    Header,
  },
  data() {
    return {
      // code: null,
      emailInput: "",
      oldPasswordInput: "",
      newPasswordInput: "",
      confirmPasswordInput: "",
      resetPasswordMessage: "",
      passwordRulesInfo:
        "Passwords require a minimum of 15 Characters, 1 of each of the following character sets: - Upper-case - Lower-case - Numerics - Special characters (e.g. ~ ! @ # $ % ^ & * ( ) _ + = - ' [ ] / ? > <)",
      passwordChanged: false,
      disabled: false,
    };
  },
  mounted() {
    // const pageParams = this.getPageUrlParameters();
    // if (!this.isNullOrEmpty(pageParams)) {
    //     this.code = pageParams.code;
    // }
  },
  computed: {
    isDisabled() {
      return this.disabled;
    },
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async onResetPasswordClicked() {
      let isValidForm = await this.$validator.validateAll();

      if (isValidForm) {
        // const email = this.emailInput;
        const newPassword = this.newPasswordInput;
        const confirmPassword = this.confirmPasswordInput;
        const oldPassword = this.oldPasswordInput;

        if (newPassword !== confirmPassword) {
          this.resetPasswordMessage =
            "The password does not match the confirmation password.";
          isValidForm = false;
        }

        if (isValidForm) {
          const passwordValid = this.isValidPassword(newPassword);

          if (!passwordValid) {
            this.resetPasswordMessage = "The password format is not valid.";
            isValidForm = false;
          }
        }

        if (isValidForm) {
          const params = {
            // Email: email,
            OldPassword: oldPassword,
            Password: newPassword,
            ConfirmPassword: confirmPassword,
            // Code: this.code
          };

          const self = this;

          self.disabled = true;
          axios
            .post("api/authentication/changepassword", params)
            .then((response) => {
              self.resetPasswordMessage = response.data;
              this.passwordChanged = true;
            })
            .catch((error) => {
              self.disabled = false;
              self.resetPasswordMessage =
                "There was an error resetting your password.";
            });
        }
      }
    },
    onReturnToLoginClicked() {
      this.$router.go(-1);
    },
  },
  watch: {
    emailInput: function () {
      this.resetPasswordMessage = "";
    },
    newPasswordInput: function () {
      this.resetPasswordMessage = "";
    },
    confirmPasswordInput: function () {
      this.resetPasswordMessage = "";
    },
  },
};
</script>

<style scoped>
.center_page {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  width: 100%;
  text-align: center;
}

.reset_password_container {
  max-width: 650px;
  padding: 20px;
  margin: 0 auto;
}

.logo_grid {
  display: grid;
  grid-template-columns: max-content 1fr;
  padding-bottom: 2px;
}

.grid_center_item {
  align-self: center;
}

.reset_password_button_grid {
  display: grid;
  grid-template-columns: 0.5fr 1fr 0.5fr;
}

@media only screen and (max-width: 768px) {
  .center_page {
    top: auto;
    transform: inherit;
    position: inherit;
    width: 100%;
    text-align: center;
  }
}
</style>
